import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_3 = {
  key: 0,
  class: "p-2 align-items-center ms-md-auto"
}
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-body" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-search",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_6 = { class: "table-responsive p-0" }
const _hoisted_7 = { class: "table align-items-center mb-0" }
const _hoisted_8 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, " Veículo ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7" }, null, -1)
const _hoisted_14 = { class: "d-flex px-2 py-1" }
const _hoisted_15 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_16 = { class: "mb-0 text-sm" }
const _hoisted_17 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_18 = { class: "text-xxs text-secondary mb-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "text-sm justify-content-center flex-column" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, null, -1)
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-eye text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-map text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.searchItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchCall(_ctx.searchIKey,_ctx.searchQuery)), ["enter"])),
                placeholder: "Procurar..."
              }, null, 544), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_8, [
                _createElementVNode("span", {
                  innerHTML: _ctx.iconSort('numero_pedido')
                }, null, 8, _hoisted_9),
                _hoisted_10,
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortData('numero_pedido')))
                }, " Pedido "),
                _createElementVNode("i", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchData('numero_pedido'))),
                  class: "fas fa-search"
                })
              ]),
              _createElementVNode("th", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortData('id_operacao'))),
                class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              }, "Endereço"),
              _hoisted_11,
              _hoisted_12,
              _hoisted_13
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (pedido) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("h6", _hoisted_16, _toDisplayString(pedido.numero_pedido), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("span", null, _toDisplayString(pedido.endereco1_cliente || "" + " " + pedido.endereco2_cliente || "") + ", " + _toDisplayString(pedido.numero_cliente || "") + " - " + _toDisplayString(pedido.bairro_cliente), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(pedido.cidade_cliente) + "/" + _toDisplayString(pedido.estado_cliente), 1)
                ]),
                _hoisted_19,
                _hoisted_20,
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.gotoPedido(pedido)),
                    "data-bs-original-title": "Visualizar Pedido"
                  }, _hoisted_24, 8, _hoisted_22),
                  _hoisted_25,
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.setCenterItem(pedido)),
                    "data-bs-original-title": "Preview product"
                  }, _hoisted_28, 8, _hoisted_26),
                  _hoisted_29,
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.removePedido(pedido)),
                    "data-bs-original-title": "Delete product"
                  }, _hoisted_32, 8, _hoisted_30)
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}